import { LocalStorageManagerService } from '../../../core/storage/local-storage-manager.service';
import { AppConfig } from '../../../core/config/app-config';
import { LoginRequest } from '../model/auth.types';

/**
 * Mirrors Consumer's modules/auth/viewmodel/loginRequestBuilder.ts.
 * `PWA_DEVICE_INFO` is a hard-coded, shared, fixed base64 blob describing a
 * fictitious device — preserved verbatim (see docs §7.2), sent on every
 * login request for every user/device on this PWA build.
 */
export const PWA_DEVICE_INFO =
  'eyJjb25zdW1wdGlvbkRldmljZU5hbWUiOiJKTVNEMjAwQSIsImluZm8iOnsidHlwZSI6ImFuZHJvaWQiLCJwbGF0Zm9ybSI6eyJuYW1lIjoiYW5kcm9pZCIsInZlcnNpb24iOiIzLjQxMzM3MjUzMzMifSwiYW5kcm9pZElkIjoiMzMwMTBjNmRlODlmZjU0NyIsImxhdGl0dWRlIjoiNTEuMTIwOTM3ODk5OTk5OTk2IiwibG9uZ2l0dWRlIjoiMTcuMDIzNzY4NTAwMDAwMCJ9fQ==';

/** Constructs a fully-formed {@link LoginRequest} from raw credentials — same field shape/order as React. */
export function buildLoginRequest(
  userName: string,
  password: string,
  localStorageManager: LocalStorageManagerService,
): LoginRequest {
  return {
    userName: userName.trim(),
    password: btoa(password),
    deviceInfo: PWA_DEVICE_INFO,
    deviceId: localStorageManager.getDeviceId(),
    appVersion: AppConfig.VERSION_NAME,
    devicesConnected: ['keyboard', 'mouse'],
    deviceRSN: '',
    jio_home_devices: 'not_connected',
  };
}
